import { cszUrl } from 'features/Env'
import { useMemo } from 'react'

export function useSchedulesLink(
  stateId: string,
  districtId: string,
  schoolId: string,
  sportId: string,
) {
  const schedulesUrl = useMemo(() => {
    const queryParams = []

    if (stateId) {
      queryParams.push(`selectedStateId=${stateId}`)
    }

    if (districtId) {
      queryParams.push(`countyId=${districtId}`)
    }

    if (schoolId) {
      queryParams.push(`schoolId=${schoolId}`)
    }

    if (sportId) {
      queryParams.push(`sportId=${sportId}`)
    }

    queryParams.push('force=true')

    return `${cszUrl}/schedules?${queryParams.join('&')}`
  }, [])

  return { schedulesUrl }
}
